var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-item--event",attrs:{"id":_vm.id}},[_c('div',{staticClass:"content-wrap"},[_vm._t("prefix"),_c('p',{staticClass:"event",style:({'--color': _vm.color})},[_vm._v(_vm._s(_vm.content))]),_vm._t("suffix")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }